// source: pbtypes/vehicle/complimentary_actions/complimentary_actions_impls/spoof_phone_inputs/spoof_phone_inputs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_ui_variables_pb = require('../../../../../pbtypes/gen/skills/ui_variables_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_ui_variables_pb);
var pbtypes_vehicle_complimentary_actions_trigger_args_pb = require('../../../../../pbtypes/vehicle/complimentary_actions/trigger_args_pb.js');
goog.object.extend(proto, pbtypes_vehicle_complimentary_actions_trigger_args_pb);
goog.exportSymbol('proto.complimentary_actions.SpoofPhoneInputsActionArgs', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.SpoofPhoneInputsActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.SpoofPhoneInputsActionArgs.displayName = 'proto.complimentary_actions.SpoofPhoneInputsActionArgs';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.SpoofPhoneInputsActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
trigger: (f = msg.getTrigger()) && pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.toObject(includeInstance, f),
durationS: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
phoneUiVariables: (f = msg.getPhoneUiVariables()) && pbtypes_gen_skills_ui_variables_pb.UiVariablesPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.SpoofPhoneInputsActionArgs}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.SpoofPhoneInputsActionArgs;
  return proto.complimentary_actions.SpoofPhoneInputsActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.SpoofPhoneInputsActionArgs}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback;
      reader.readMessage(value,pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDurationS(value);
      break;
    case 3:
      var value = new pbtypes_gen_skills_ui_variables_pb.UiVariablesPb;
      reader.readMessage(value,pbtypes_gen_skills_ui_variables_pb.UiVariablesPb.deserializeBinaryFromReader);
      msg.setPhoneUiVariables(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.SpoofPhoneInputsActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.serializeBinaryToWriter
    );
  }
  f = message.getDurationS();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getPhoneUiVariables();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_skills_ui_variables_pb.UiVariablesPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional TriggerArgs.TimerCallback trigger = 1;
 * @return {?proto.complimentary_actions.TriggerArgs.TimerCallback}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.getTrigger = function() {
  return /** @type{?proto.complimentary_actions.TriggerArgs.TimerCallback} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback, 1));
};


/**
 * @param {?proto.complimentary_actions.TriggerArgs.TimerCallback|undefined} value
 * @return {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} returns this
*/
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} returns this
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float duration_s = 2;
 * @return {number}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.getDurationS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} returns this
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.setDurationS = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional skills.UiVariablesPb phone_ui_variables = 3;
 * @return {?proto.skills.UiVariablesPb}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.getPhoneUiVariables = function() {
  return /** @type{?proto.skills.UiVariablesPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_ui_variables_pb.UiVariablesPb, 3));
};


/**
 * @param {?proto.skills.UiVariablesPb|undefined} value
 * @return {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} returns this
*/
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.setPhoneUiVariables = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.SpoofPhoneInputsActionArgs} returns this
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.clearPhoneUiVariables = function() {
  return this.setPhoneUiVariables(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.SpoofPhoneInputsActionArgs.prototype.hasPhoneUiVariables = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.complimentary_actions);
